import email from '../assets/email.png';

import circle from '../assets/circle.svg';
import logo from '../assets/bg-snabk.png';

import mobile from '../assets/mobile.png';
import radio from '../assets/radio.png';
import montage from '../assets/montage.png';
import videoCamera from '../assets/video-camera.png';

export default {
  email,
  circle,
  logo,
  radio,
  mobile,
  montage,
  videoCamera,
};
